import { Brand } from '../ui/Brand.jsx';
import { isNativePlatform } from '../services/native/platformService.js';

// This also renders before session rehydration, so it must not depend on a
// router or display any account information. Native retains its launch splash.
export function AppLoading() {
  if (isNativePlatform()) return null;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-paper text-ink">
      <Brand />
      <div role="status" className="flex items-center gap-3 text-sm text-muted">
        <span aria-hidden="true" className="h-5 w-5 rounded-full border-2 border-line border-t-teal animate-spin motion-reduce:animate-none" />
        <span>Loading…</span>
      </div>
    </div>
  );
}
